"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const CheckBoxCell_1 = require("../../../elements/CheckBoxCell");
const GroupPane_1 = require("../../../elements/GroupPane");
const ReactTable_1 = __importDefault(require("../../../elements/ReactTable/ReactTable"));
const FormikInput_1 = __importDefault(require("../../../elements/formik/FormikInput"));
const FormikSelect_1 = __importDefault(require("../../../elements/formik/FormikSelect"));
const DataSelectionOptions = [
    { label: 'FT', value: 'ft' },
    { label: 'FID', value: 'fid' },
    { label: 'Both', value: 'both' },
    { label: 'Prefer FT', value: 'preferFT' },
    { label: 'Prefer FID', value: 'preferFID' },
];
const GENERAL_LIST = [
    {
        label: 'Keep 1D',
        name: 'general.keep1D',
        fieldType: 'checkbox',
    },
    {
        label: 'Keep 2D',
        name: 'general.keep2D',
        fieldType: 'checkbox',
    },
    {
        label: 'Only Real',
        name: 'general.onlyReal',
        fieldType: 'checkbox',
    },
    {
        label: 'Data Selection',
        name: 'general.dataSelection',
        fieldType: 'select',
        options: DataSelectionOptions,
    },
];
const BRUKER_LIST = [
    {
        label: 'Processing Numbers',
        name: 'bruker.processingNumbers',
        fieldType: 'input',
    },
    {
        label: 'Experiment Numbers',
        name: 'bruker.experimentNumbers',
        fieldType: 'input',
    },
    {
        label: 'Only First Processed Data',
        name: 'bruker.onlyFirstProcessedData',
        fieldType: 'checkbox',
    },
];
const COLUMNS = [
    {
        Header: '#',
        style: { width: '10px' },
        accessor: (_, index) => index + 1,
    },
    {
        Header: 'Feature',
        accessor: 'label',
        style: { width: '70%' },
    },
    {
        Header: ' ',
        Cell: ({ row }) => {
            const fieldType = row.original.fieldType;
            switch (fieldType) {
                case 'checkbox':
                    return ((0, jsx_runtime_1.jsx)(CheckBoxCell_1.CheckBoxCell, { name: `nmrLoaders.${row.original.name}`, defaultValue: false }));
                case 'input':
                    return ((0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `nmrLoaders.${row.original.name}`, type: "string", style: { input: { width: '100%', padding: 0 } } }));
                case 'select':
                    return ((0, jsx_runtime_1.jsx)(FormikSelect_1.default, { name: `nmrLoaders.${row.original.name}`, style: { width: '100%' }, items: row.original.options }));
                default:
                    return (0, jsx_runtime_1.jsx)("span", {});
            }
        },
    },
];
function ImportationFiltersTabContent() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "General", children: (0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: COLUMNS, data: GENERAL_LIST }) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Bruker", children: (0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: COLUMNS, data: BRUKER_LIST }) })] }));
}
exports.default = ImportationFiltersTabContent;
